import { useEffect, useState } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { href: '#audios', label: 'Áudios' },
    { href: '#beneficios', label: 'Benefícios' },
    { href: '#precos', label: 'Oferta' },
    { href: '#depoimentos', label: 'Depoimentos' },
    { href: '#faq', label: 'FAQ' },
  ];

  const scrollTo = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
      role="banner"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500">
              <i className="ri-sound-module-line text-background-50 text-lg" />
            </div>
            <span className={`font-heading text-lg md:text-xl font-bold transition-colors whitespace-nowrap ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              Áudio Cura
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1" aria-label="Navegação principal">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                className={`px-3 py-2 text-sm font-medium transition-colors rounded-md whitespace-nowrap cursor-pointer focus-visible:outline-2 focus-visible:outline-accent-500 ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-background-200/90 hover:text-background-50'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <a
              href="#precos"
              onClick={(e) => { e.preventDefault(); scrollTo('#precos'); }}
              className="inline-flex items-center whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-full font-semibold text-sm transition-all focus-visible:outline-2 focus-visible:outline-accent-500 bg-accent-500 text-background-50 hover:bg-accent-600 shadow-lg shadow-accent-500/20"
            >
              Quero Agora
              <i className="ri-arrow-right-line ml-1.5" />
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors"
            aria-label="Abrir menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-800' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/70 px-4 pb-4">
          <nav className="flex flex-col gap-1 pt-2" aria-label="Navegação mobile">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#precos"
              onClick={(e) => { e.preventDefault(); scrollTo('#precos'); }}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-full font-semibold text-sm transition-all bg-accent-500 text-background-50 hover:bg-accent-600"
            >
              Quero Agora
              <i className="ri-arrow-right-line ml-1.5" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}